import { Point } from "../../engine/space/bounds";
import { Directions, getDirectionTowards } from "../../engine/space/directions";
import { gameData } from "../GameManager";
import { adjInCheck, adjOutCheck } from "./Movement";

export const moveIn = (to: Point, from: Point) => {
  const tile = gameData.current.tiles[from.x + from.y * gameData.current.width];

  switch (getDirectionTowards(from, to)) {
    case Directions.Left:
      return adjInCheck(tile.adj.left);
    case Directions.Up:
      return adjInCheck(tile.adj.up);
    case Directions.Right:
      return adjInCheck(tile.adj.right);
    case Directions.Down:
      return adjInCheck(tile.adj.down);
  }
};
export const moveOut = (to: Point, from: Point) => {
  const tile = gameData.current.tiles[from.x + from.y * gameData.current.width];

  switch (getDirectionTowards(from, to)) {
    case Directions.Left:
      return adjOutCheck(tile.adj.left);
    case Directions.Up:
      return adjOutCheck(tile.adj.up);
    case Directions.Right:
      return adjOutCheck(tile.adj.right);
    case Directions.Down:
      return adjOutCheck(tile.adj.down);
  }
};
